import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    View,
    TextInput,
    ImageBackground,
    StyleSheet,
    Keyboard,
    Platform,
    TouchableOpacity,
} from 'react-native';

import { get, post } from '../common/fetch';
import { tip } from '../common/utils';

import { NavBar, TabBar, utils, Link } from '@ltfe/ltfe-core-lib';
import { JDImage, JDText, JDTouchable, JDJumping } from '@jdreact/jdreact-core-lib';
import { getImageUrl } from '../common/newImg';
import List from '../components/yingdou-list';
import st from '../style/yingdou-list';
import { Alert as AlertModel } from '../common/model/index'
const { pt, deviceHeight } = utils;
const IMG = {
    jd_bean: getImageUrl('jd_bean'),
    cicle_bg: getImageUrl('cicle_bg'),
    adv: 'https://img11.360buyimg.com/imagetools/jfs/t1/79848/17/24851/187061/64116027Fb9c745b5/009ea7f7b0439c8a.png'
};
const FIR = 0;
const SEC = 1;
const isWeb = Platform.OS === 'web';
class YingDouList extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            // 充值弹窗选中的tab签，0：电子卡，1：实体卡
            currentId: FIR,
            // 产品修改为 一直是第一步当前步骤
            currentStep: FIR,
            // 是否展示充值弹窗
            isOpenAlert: false,
            // 电子卡、实体卡
            cardTabArr: [
                {
                    label: '电子卡',
                    id: FIR,
                    steps: [
                        { titleTxt: '请输入充值信息', btnTxt: '确认充值' },
                        { titleTxt: '请输入卡号密码', btnTxt: '确认绑定' }
                    ]
                },
                {
                    label: '实体卡',
                    id: SEC,
                    steps: [
                        { titleTxt: '请输入充值信息', btnTxt: '确认充值' }
                    ]
                }
            ],
            // 充值行为时产生的错误信息
            errMsg: '',
            inputElectronicCardNum: '',
            // inputElectronicPassword: '',
            inputEntityCardNum: '',
            inputEntityPassword: '',
            // 影豆头部信息
            movieBeanData: {},
            keyboardHeight: 0, //键盘高度
            alertHeight: 212, // t弹窗高度
            pageHeight: deviceHeight, // 页面高度,
            autoFocus: Platform.OS === 'ios', // IOS自动获取焦点
        };

        // this.inputElectronicCardNum = React.createRef();
        // this.inputElectronicPassword = React.createRef();
        // this.inputEntityCardNum = React.createRef();
        // this.inputEntityPassword = React.createRef();
    };

    getMovieBean = () => {
        get('mv_movieBean_myMovieBean_summary', {})
            .then((res) => {
                if (res.errCode === undefined || res.errCode === null || res.errCode === '') {
                    return;
                }
                if (parseInt(res.errCode) === 0) { // 表示成功
                    const { availableQuantity, aboutToExpireQuantity } = res.data;

                    this.setState({
                        movieBeanData: {
                            availableQuantity,
                            aboutToExpireQuantity
                        }
                    });
                }
            });
    }
    advertisingSpace = () => {
        const RN = `openapp.jdmobile://virtual?params={"category":"jump","des":"jdmp","appId":"ED2AA7211D811DD081E8B321515A070C","vapptype":"1","path":"","scene":"1001"}`;
        const H5 = `https://mini-app-static.jd.com/apps/mpshare/index.html?category=jump&des=jdmp&vapptype=1&appId=ED2AA7211D811DD081E8B321515A070C&path=&scene=1001`;
        if (isWeb) {
            location.href = H5;
        } else {
            JDJumping.jumpToOpenapp(RN).catch(err => tip(err));
        }
    }
    onTabFetchList = (param = {}) => {
        return post('mv_myMovieBean_accountRecord', { ...param }, true)
            .then((res) => {
                if (res.errCode === undefined || res.errCode === null || res.errCode === '') {
                    return res;
                } else if (parseInt(res.errCode) === 0) {
                    return {
                        ...res,
                        data: {
                            ...res.data,
                            list: res?.data?.accountRecordList || []
                        }
                    };
                }

                return res;
            });
    }

    onTab2FetchList = (param = {}) => {
        return post('mv_myMovieBean_aboutToExpireDetail', { ...param }, true)
            .then((res) => {
                if (res.errCode === undefined || res.errCode === null || res.errCode === '') {
                    return res;
                } else if (parseInt(res.errCode) === 0) {
                    return {
                        ...res,
                        data: {
                            ...res.data,
                            list: res?.data?.aboutToExpireDetailList || []
                        }
                    };
                }

                return res;
            });
    }

    componentDidMount() {
        this.getMovieBean();
    }

    render() {
        const {
            isOpenAlert,
            currentId,
            cardTabArr,
            currentStep,
            movieBeanData,
            pageHeight,
            alertHeight
        } = this.state;
        const tabObj = cardTabArr[currentId]?.steps[currentStep];
        const showAlert = false;

        return (
            <View style={ st.container }>
                <NavBar title="京东影豆卡" />
                <JDImage source={ { uri: IMG.cicle_bg } } style={ [st.top_wrap, !movieBeanData?.aboutToExpireQuantity ? {} : st.pt15] }>
                    <View>
                        <View style={ st.flex_row } >
                            <JDImage source={ { uri: IMG.jd_bean } } style={ st.jd_bean } />
                            <JDText type='regular' style={ st.top_num }>{movieBeanData?.availableQuantity || 0}</JDText>
                        </View>
                        <JDText style={ st.top_txt }>
                            {
                                !movieBeanData?.aboutToExpireQuantity
                                    ? '您未来1个月无过期影豆'
                                    : `您未来一个月内即将过期${movieBeanData?.aboutToExpireQuantity}影豆，请及时消费`
                            }
                        </JDText>
                    </View>
                    <View style={ [st.abs, !movieBeanData?.aboutToExpireQuantity ? {} : st.top25] }>
                        <Link style={ st.btn } onPress={ this.toggleAlert }>
                            <JDText type='bold' style={ st.btn_txt }>去充值</JDText>
                        </Link>
                    </View>
                </JDImage>

                
                <TabBar
                    tabStyle={ { height: pt(44), paddingBottom: pt(4) } }
                    activeTabStyle={ st.active_tab }
                    inactiveTabStyle={ st.inactive_tab }
                    scrollEnabled={ false }
                    tabUnderLineColor={ ['#FC1B00', '#FC1B00'] }
                >
                    <View
                        tabLabel='影豆收支明细' style={ styles.tabItem }>
                        <List
                            ref={ (list1) => {
                                this.list1 = list1;
                            } }
                            onFetchList={ this.onTabFetchList }
                        />
                    </View>
                    <View
                        tabLabel='1个月内即将到期影豆明细'
                        style={ styles.tabItem }
                    >
                        <List
                            ref={ (list2) => {
                                this.list2 = list2;
                            } }
                            onFetchList={ this.onTab2FetchList }
                        />
                    </View>
                </TabBar>

                <AlertModel
                  title={ tabObj.titleTxt }
                  content={ this.renderContent() }
                  show={ showAlert }
                  overlayClickable={ false }
                  isShowButton={ true }
                  confirmText={tabObj.btnTxt}
                  cancelText="取消"
                  isShowCancel={ true }
                  onCancel={ this.chargeCancel }
                  onConfirm={ this.chargeConfirm }
                  alertStyle={{
                    top: (pageHeight-alertHeight)/2,
                    left: `calc(50vw - 145px)`,
                    position: 'absolute',
                    width: 291,
                    height: alertHeight,
                }}
                />
              {
                 isOpenAlert && <>
                  <View style={{
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    zIndex: 1,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    width: '100vw',
                    height: '100vh'
                  }}></View>
                  <View style={{
                    backgroundColor: '#ffffff',
                    width: 290,
                    height: alertHeight,
                    position: 'absolute',
                    zIndex: 10,
                    left: 'calc(50vw - 145px)',
                    top: 'calc(50vh - 130px)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '10px'
                  }}>
                    <View style={{
                      fontWeight: 'bold',
                      fontSize: '16px',
                      lineHeight: '40px',
                      height: '40px'
                    }}>{tabObj.titleTxt}</View>
                    {
                      this.renderContent()
                    }
                    <View style={{
                      display: 'flex',
                      width: '100%',
                      flexDirection: 'row'
                    }}>
                      <View style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                        <TouchableOpacity style={{
                          width: '112px',
                          height: '31px',
                          marginRight: '10px',
                          marginLeft: '10px',
                          textAlign: 'center',
                          borderStyle: 'solid',
                          borderWidth: '1px',
                          borderRadius: '17px',
                          borderColor: 'rgb(242, 39, 12)',
                          lineHeight: '31px',
                          fontSize: '12px',
                          color: 'rgb(242, 39, 12)'
                        }} onPress={this.chargeCancel}>取消</TouchableOpacity>
                      </View>
                      <View style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                        <TouchableOpacity style={{
                          width: '112px',
                          height: '31px',
                          marginRight: '10px',
                          marginLeft: '10px',
                          textAlign: 'center',
                          borderStyle: 'solid',
                          borderWidth: '1px',
                          borderRadius: '17px',
                          lineHeight: '31px',
                          color: 'rgb(255, 255, 255)',
                          borderColor: 'none',
                          fontSize: '12px',
                          backgroundImage: 'linear-gradient(135deg, rgb(241, 0, 0) 20%, rgb(255, 32, 0) 70%, rgb(255, 79, 24) 100%)'
                        }} onPress={this.chargeConfirm}>{tabObj.btnTxt}</TouchableOpacity>
                      </View>
                    </View>
                  </View>
                </>
              }
            </View>
        );
    }

    renderContent = () => {
        const { currentId, cardTabArr, currentStep, errMsg } = this.state;
        const { inputElectronicCardNum, inputEntityCardNum, inputEntityPassword } = this.state;

        return <View style={ st.content_wrap } onLayout={ (e) => this.setAlertHeight(e.nativeEvent.layout.height) }>
            <View style={ st.content_tab }>
                {
                    cardTabArr.map((ele) =>
                        <Link
                            key={ ele.id }
                            style={ [st.tab, currentId === ele.id && st.tab_cur] }
                            onPress={ () => this.switchTab(ele.id) }>
                            <JDText type={ currentId === ele.id ? 'bold' : 'regular' }>{ele.label}</JDText>
                        </Link>
                    )
                }

            </View>
            {currentId === FIR && <View>
                {currentStep === FIR && <TextInput className={'input-alert'} style={ st.input_wrap } placeholder='请输入卡号' onChangeText={ (val) => this.onChangeHandler('inputElectronicCardNum', val) } value={ inputElectronicCardNum } />}
                {/* {currentStep === SEC && <View>
                    <JDText style={ st.alert_msg }>该兑换券在2021-09-21前可激活并绑定，激活后有效期至2021-10-21，是否确认激活并绑定？</JDText>
                    <TextInput style={ st.input_wrap } placeholder='请输入密码' onChangeText={ (val) => this.onChangeHandler('inputElectronicPassword', val) } value={ inputElectronicPassword } />
                </View>} */}
            </View>}
            {currentId === SEC && <View>
                <TextInput className={'input-alert'} style={ st.input_wrap } placeholder='请输入卡号' onChangeText={ (val) => this.onChangeHandler('inputEntityCardNum', val) } value={ inputEntityCardNum } />
                <TextInput style={ st.input_wrap } placeholder='请输入密码' onChangeText={ (val) => this.onChangeHandler('inputEntityPassword', val) } value={ inputEntityPassword } />
            </View>}
            {errMsg !== '' && <JDText style={ st.err_txt } type='regular'>{errMsg}</JDText>}
        </View>;
    }


  setAlertHeight(e){
    // this.setState({ alertHeight: e });
  }

  componentWillMount() {
    const that = this;
    const originalHeight = document.documentElement.clientHeight || document.body.clientHeight;
    setTimeout(_=>{
      window.resize = () => {
        //键盘弹起与隐藏都会引起窗口的高度发生变化
        const resizeHeight = document.documentElement.clientHeight || document.body.clientHeight;
        if (resizeHeight < originalHeight) {
          // 当软键盘弹起，在此处操作!!!
          document.querySelectorAll('input').forEach(value => {
            value.addEventListener('click', _=>{
              try {
                value.scrollIntoView({
                  block: 'end',
                  behavior: 'smooth'
                });
              } catch (error) {
                const newHeight = (deviceHeight) - (deviceHeight * 0.35);
                that.setState({ pageHeight: newHeight })
              }
            })
          })
        } else {
          that.setState({ pageHeight: originalHeight })
        }
      }
      const ua = navigator.userAgent;
      const iOS = /iPad|iPhone|iPod/.test(ua);
      document.body.addEventListener('focusin', () => {
        // 软键盘弹出的事件处理
        if (iOS){}
      })
      document.body.addEventListener('focusout', () => {
        // 软键盘收起的事件处理
        if (iOS){
          document.body.scrollTop = 0;
        }
      })
    }, 20)
  }

  scrollHeightSetting(type = 'addEventListener'){
    const ua = navigator.userAgent;
    const iOS = /iPad|iPhone|iPod/.test(ua);
    const that = this;
    document.querySelectorAll('input').forEach(value => {
      value[type]('focus', () => {
        console.warn('输入框已获取焦点');
        setTimeout(() => {
          if (iOS) {
            if (!/OS 11_[0-3]\D/.test(ua)) {
              document.body.scrollTop = document.body.scrollHeight;
            }
          } else {
            try {
              value.scrollIntoView({ block: 'end', behavior: 'smooth'});
            } catch (error) {
              const newHeight = (deviceHeight) - (deviceHeight * 0.35);
              that.setState({ pageHeight: newHeight })
            }
          }
        }, 300);
      });
      // 失去焦点以后;
      value[type]('blur', () => {
        if (iOS) {
          document.body.scrollTop = 0;
        } else {
          that.setState({
            pageHeight: deviceHeight
          })
        }
      })
    });
  }

  componentWillUnmount() {
      // 移除监听
    this.scrollHeightSetting('removeEventListener');
  }

    onChangeHandler = (type, val) => {
      console.log(type, val);
      const pattern = /^[a-zA-Z0-9]{1,20}$/gm;
      const validate = pattern.test(val)
      console.log(type,val,validate);
      if (validate || !val) {
        this.setState({ [type]: val });
      }
    }

    toggleAlert = () => {
        const { isOpenAlert } = this.state;
        this.setState({
          isOpenAlert: !isOpenAlert
        }, _=> {
          // 弹窗显示就开启监听
          !isOpenAlert && this.scrollHeightSetting('addEventListener');
        });
    }

    resetInput = () => {
        this.setState({
            inputElectronicCardNum: '',
            inputElectronicPassword: '',
            inputEntityCardNum: '',
            inputEntityPassword: ''
        });
    }

    resetStep = () => {
        this.setState({ currentStep: FIR, errMsg: '' });
    }

    switchTab = (id) => {
        this.resetStep();
        this.setState({
          currentId: id
        },_=> {
          if (id === FIR) this.setState({ alertHeight: 212 });
          if (id === SEC)  this.setState({ alertHeight: 262 });
          setTimeout(_=> this.scrollHeightSetting('addEventListener'), 200)
        });
    }

    chargeCancel = () => {
        this.resetStep();
        this.resetInput();
        this.toggleAlert();
    }

    onFreshPage = () => {
        // 获取影豆数量， 页面初始化也调用它
        this.getMovieBean();
        // 调用影豆收入明细
        this.list1.init(false);
        // 调用1个月内即将到期的影豆
        this.list2.init(false);
    }

    chargeFetch = (callback = () => {}) => {
        const {
            currentId,
            inputElectronicCardNum,
            inputEntityCardNum,
            inputEntityPassword
        } = this.state;

        const param = {
            cardType: currentId === FIR ? 0 : 1,
            certNum: currentId === FIR ? inputElectronicCardNum : inputEntityCardNum
        };

        if (currentId === SEC) {
            param.certPwd = inputEntityPassword;
        }

        post('mv_movieBean_bind', {
            ...param
        }, true).then((res) => {
            if (parseInt(res?.errCode || 0) === 2710) {
                tip('充值成功');

                return callback();
            }
            tip(res?.errMsg || '充值失败');
        }).catch((err) => {
            tip(err.errMsg || '充值失败');
        });
    }

    chargeConfirm = () => {
        const {
            currentId,
            inputElectronicCardNum,
            inputEntityCardNum,
            inputEntityPassword
        } = this.state;

        if (currentId === FIR) {
            // if (currentStep === FIR) {
            // 校验
            if (inputElectronicCardNum === '') {
                this.setState({ errMsg: '请输入卡号' });
            } else {
                // 充值成功的回调
                this.chargeFetch(() => {
                    setTimeout(() => {
                        this.onFreshPage();
                    }, 500);
                    this.chargeCancel();
                });

                this.setState({
                    errMsg: ''
                    // inputElectronicPassword: ''
                });
            }
        } else if (currentId === SEC) {
            if (!inputEntityCardNum) {
                this.setState({ errMsg: '请输入卡号' });
            } else if (!inputEntityPassword) {
                this.setState({ errMsg: '请输入密码' });
            } else {
                this.setState({
                    errMsg: ''
                });
                this.chargeFetch(() => {
                    setTimeout(() => {
                        this.onFreshPage();
                    }, 500);
                    this.chargeCancel();
                });
            }
        }
    }
}

YingDouList.contextTypes = { router: PropTypes.object };

const select = () => {
    return {

    };
};

export default connect(select, null, null, { withRef: true })(YingDouList);

const styles = StyleSheet.create({
    tabItem: {
        width: pt(375),
        height: '100%'
    }
});
